var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScrewLag = function SvgScrewLag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10 19.3 4-2.7V20l-2 2-2-2zm4-6.6-4 2.7v2L9 18v1l6-3.9V14l-1 .7zM7 2v3h10V2zm2 4v3l1 .7v3.7L9 14v1l6-3.9V10l-1 .7v-1l1-.7V6z"
  })));
};
export { SvgScrewLag as ReactComponent };
export default "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M10 19.3L14 16.6V20L12 22L10 20V19.3ZM14 12.7L10 15.4V17.4L9 18V19L15 15.1V14L14 14.7V12.7V12.7ZM7 2V5H17V2H7ZM9 6V9L10 9.7V13.4L9 14V15L15 11.1V10L14 10.7V9.7L15 9V6H9Z' fill='%234A6067'/%3e %3c/svg%3e";